module.exports = __webpack_public_path__ + "img/Travel-Trailer-Desktop.089e8834.jpg";